import type { CityConfig } from "@/pages/city-template/types";

export const albanyNyConfig: CityConfig = {
  city: "Albany",
  state: "New York",
  stateAbbr: "NY",
  slug: "albany-ny",
  route: "/cities/albany-ny",
  title: "Emergency & Expedited Passport Albany, NY | Same Day Passport Services",
  metaDescription:
    "Emergency passport Albany NY — same day, 24-hour, and 3-5 day expedited passport processing. Fast Passport Center serves Albany, Troy, Schenectady, Saratoga Springs, and all of Capital Region. Avoid the 8-11 week wait.",
  h1: "Emergency & Expedited Passport Services in Albany, NY",
  heroSubtitle:
    "Albany is the capital of New York State — and its travelers deserve passport service that matches the city's importance. Fast Passport Center delivers emergency passports as quick as 24 hours, with 3-5 day expedited service for Albany, Troy, Schenectady, Saratoga Springs, and the entire Capital Region.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Albany%20New%20York%20skyline%20with%20New%20York%20State%20Capitol%20building%20at%20golden%20hour%2C%20historic%20dome%20and%20modern%20downtown%20buildings%2C%20warm%20sunset%20lighting%2C%20Empire%20State%20Plaza%20in%20foreground%2C%20modern%20travel%20photography%2C%20clean%20composition%2C%20no%20text%20overlay%2C%20high%20contrast%20urban%20capital%20city%20landscape%20with%20Hudson%20River%20Valley%20backdrop&width=1600&height=700&seq=ny-albany-hero-001&orientation=landscape",
  heroImageAlt: "Albany New York skyline with New York State Capitol building at golden hour",
  geoPosition: "42.6526; -73.7562",
  geoPlacename: "Albany, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~150 miles from Albany",
  },
  nearbyCitiesZips: [
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Troy", zips: "12180, 12181, 12182, 12183" },
    { name: "Schenectady", zips: "12301-12309, 12325, 12345" },
    { name: "Saratoga Springs", zips: "12866" },
    { name: "Rensselaer", zips: "12144" },
    { name: "East Greenbush", zips: "12061" },
    { name: "Watervliet", zips: "12189" },
    { name: "Cohoes", zips: "12047" },
    { name: "Guilderland", zips: "12084, 12085, 12203, 12211" },
    { name: "Colonie", zips: "12205, 12211" },
    { name: "Bethlehem", zips: "12054, 12077, 12158, 12159, 12203" },
    { name: "Rotterdam", zips: "12303, 12306" },
    { name: "Niskayuna", zips: "12309" },
    { name: "Scotia", zips: "12302" },
    { name: "Ballston Spa", zips: "12020" },
    { name: "Malta", zips: "12020" },
    { name: "Glens Falls", zips: "12801, 12804" },
    { name: "Hudson Falls", zips: "12839" },
    { name: "New York City", zips: "10001-10045, 10199, 10280, 10282" },
    { name: "Buffalo", zips: "14201-14204, 14206-14210, 14211-14214, 14215, 14216, 14217, 14218, 14219, 14220, 14221, 14222, 14223, 14224, 14225, 14226, 14227, 14228, 14231, 14233, 14240, 14241, 14260, 14261, 14263, 14264, 14265, 14267, 14269, 14270, 14272, 14273, 14276, 14280" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Albany travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with reserved agency submission slots.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Capital Region Coverage",
      desc: "Albany, Troy, Schenectady, Saratoga Springs, and every community in the Capital Region.",
    },
  ],
  testimonials: [
    {
      name: "Karen S.",
      location: "Albany, NY",
      rating: 5,
      text: "I needed an emergency passport for a work trip to Europe. Fast Passport Center got it done in 4 days. The agent was incredibly helpful and kept me informed throughout.",
      service: "Emergency Passport",
    },
    {
      name: "James P.",
      location: "Troy, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 4. Very professional service.",
      service: "Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Schenectady, NY",
      rating: 5,
      text: "First-time passport for my teenager. The agent explained the parental consent rules clearly and helped us avoid mistakes. Processed in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "alb-1",
      name: "Albany Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "122 William Street",
      city: "Albany",
      state: "NY",
      zip: "12222",
      phone: "518-452-7271",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Albany",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Albany passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "alb-2",
      name: "Troy Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "400 Broadway",
      city: "Troy",
      state: "NY",
      zip: "12180",
      phone: "518-274-0324",
      hours: "Mon-Fri 8:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Troy, NY (~10 miles from Albany)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Troy and Rensselaer County residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "alb-3",
      name: "Schenectady Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "29 Jay Street",
      city: "Schenectady",
      state: "NY",
      zip: "12305",
      phone: "518-393-5601",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      distance: "Schenectady, NY (~20 miles from Albany)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Nearby alternative for Schenectady and Capital Region residents.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Albany, NY?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Albany residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Albany?",
      a: "The Albany Main Post Office at 122 William Street offers passport acceptance services. The Troy Post Office at 400 Broadway (~10 miles) and Schenectady Post Office at 29 Jay Street (~20 miles) are also nearby alternatives. First-time applicants and those not eligible for mail-in renewal must apply in person at these facilities. Fast Passport Center guides you through the acceptance clerk process.",
    },
    {
      q: "Can I get same-day passport photos in Albany, NY?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations in Albany, Troy, and Schenectady. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements before submission.",
    },
    {
      q: "How much does an expedited passport cost in Albany?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Albany passport needs.",
    },
    {
      q: "Do I need to drive to the New York Passport Agency from Albany?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency at 376 Hudson Street in Manhattan at all. As a registered courier, we handle the agency submission for you. The drive is approximately 150 miles, making it impractical for most Albany residents.",
    },
    {
      q: "What is the fastest way to renew a passport in Albany, New York?",
      a: "The fastest way to renew a passport in Albany is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Albany, NY?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Albany and all of the Capital Region. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Albany, NY?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Albany. We serve Albany and all of the Capital Region through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Albany / Troy", address: "various CVS locations in Albany, Troy, and Schenectady", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Albany / Schenectady", address: "various Walgreens locations near Albany and Capital Region", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Albany", address: "various UPS Store locations in Albany and Troy", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Albany", address: "various FedEx Office locations in Albany", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart — Albany", address: "various Walmart locations near Albany", hours: "Mon-Sun 7:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Albany",
      address: "224-260 Wolf Road, Albany, NY 12205",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Capital Region DMV office. Accepts walk-ins but appointments are strongly recommended. REAL ID and driver's license services.",
      featured: true,
    },
    {
      name: "NYS DMV — Troy",
      address: "1600 7th Avenue, Troy, NY 12180",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Troy DMV office for license renewals and REAL ID applications. Convenient for Troy and Rensselaer County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "In Albany, NY",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with domestic flights and some seasonal international connections. Convenient for Albany-area travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~150 miles from Albany",
      address: "Queens, NY 11430",
      note: "NYC's primary international airport with direct flights worldwide. Many Albany travelers use JFK for international travel.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
    {
      code: "BDL",
      name: "Bradley International Airport",
      distance: "~80 miles from Albany (in Hartford, CT)",
      address: "Schoephoester Rd, Windsor Locks, CT 06096",
      note: "Connecticut's major airport with domestic and some international service. Alternative option for Albany-area travelers.",
      flightUrl: "https://www.bradleyairport.com/",
      flightLabel: "Bradley International",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Albany travelers with urgent departures within 24 hours to 2 weeks. Reserved agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Albany residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Albany residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Albany residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Albany, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Albany residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Albany travelers with immediate departure needs." },
    { name: "Passport Renewal", description: "Fast passport renewal for Albany residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Albany residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Albany residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Albany." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Albany." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Albany travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Albany travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Capital Region team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application with reserved agency processing slots.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Albany address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Malone", route: "/cities/malone" },
    { name: "Tupper Lake", route: "/cities/tupper-lake" },
    { name: "Rome", route: "/cities/rome-ny" },
    { name: "Lake George", route: "/cities/lake-george" },
    { name: "Ballston Spa", route: "/cities/ballston-spa" },
    { name: "Hudson", route: "/cities/hudson-ny" },
    { name: "Chatham", route: "/cities/chatham" },
    { name: "Catskill", route: "/cities/catskill" },
    { name: "Amsterdam", route: "/cities/amsterdam-ny" },
    { name: "Gloversville", route: "/cities/gloversville" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Albany and all of the Capital Region as a remote courier service. We do not have a physical office in Albany, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Albany, NY area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Albany and all surrounding Capital Region communities. From Troy to Schenectady, Saratoga Springs to Glens Falls — we serve every Capital Region community with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Albany and all surrounding Capital Region communities. Whether you're in the city or the suburbs, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Albany customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Albany travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Albany and Capital Region travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Albany, NY. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default albanyNyConfig;